import React from "react"
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card"
import { Skeleton } from "../ui/skeleton"
import {
  Dumbbell,
  CheckCircle2,
  Clock,
  Users,
  BookOpen,
} from "lucide-react"

const StatCard = ({ title, value, icon: Icon, isLoading, description }) => (
  <Card className="overflow-hidden">
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-muted-foreground truncate">
            {title}
          </p>
          {isLoading ? (
            <Skeleton className="h-8 w-24 mt-2" />
          ) : (
            <p className="text-2xl font-bold mt-2 tabular-nums">{value}</p>
          )}
          {description && !isLoading && (
            <p className="text-xs text-muted-foreground mt-1">{description}</p>
          )}
        </div>
        {Icon && (
          <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 ml-4">
            <Icon className="h-5 w-5 text-primary" />
          </div>
        )}
      </div>
    </CardContent>
  </Card>
)

function StatsOverview({ stats, isLoading }) {
  const completionRate =
    stats.totalWorkouts > 0
      ? ((stats.completedWorkouts / stats.totalWorkouts) * 100).toFixed(1) + "%"
      : "N/A"

  const avgDuration = stats.avgDuration
    ? Math.round(stats.avgDuration / 60) + " min"
    : "N/A"

  const completedCount = stats.completedWorkouts ?? 0
  const cancelledCount = stats.cancelledWorkouts ?? 0

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Stats Overview</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4">
          <StatCard
            title="Total Workouts"
            value={stats.totalWorkouts ?? "N/A"}
            isLoading={isLoading}
            description={
              stats.totalWorkouts > 0
                ? `${completedCount} completed, ${cancelledCount} cancelled`
                : undefined
            }
            icon={Dumbbell}
          />
          <StatCard
            title="Completion Rate"
            value={completionRate}
            isLoading={isLoading}
            icon={CheckCircle2}
          />
          <StatCard
            title="Avg Duration"
            value={avgDuration}
            isLoading={isLoading}
            icon={Clock}
          />
          <StatCard
            title="Unique Users"
            value={stats.uniqueUsers ?? "N/A"}
            isLoading={isLoading}
            icon={Users}
          />
          <StatCard
            title="Total Exercises"
            value={
              stats.totalExercises
                ? stats.totalExercises.toLocaleString()
                : "N/A"
            }
            isLoading={isLoading}
            icon={BookOpen}
          />
        </div>
      </CardContent>
    </Card>
  )
}

export default StatsOverview
